"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmYesNo = exports.confirmAlert = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var index_1 = __importStar(require("../Button/index"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var index_2 = __importDefault(require("../Modal/index"));
var removeConfirmElement = function () {
    var target = document.getElementById("react-confirm-alert");
    if (target && target.parentNode) {
        react_dom_1.unmountComponentAtNode(target);
        target.parentNode.removeChild(target);
    }
};
var confirmAlert = function (props) {
    var divTarget = document.createElement("div");
    divTarget.id = "react-confirm-alert";
    document.body.appendChild(divTarget);
    react_dom_1.render(react_1.default.createElement(ConfirmAlert, __assign({}, props)), divTarget);
};
exports.confirmAlert = confirmAlert;
var confirmYesNo = function (message, success, props) {
    if (props === void 0) { props = {}; }
    var alertProps = {
        message: message,
        buttons: [
            {
                id: "yes",
                label: LocaleProvider_1.default.locs.confirmation.yes,
                variant: props.confirmButtonType || index_1.ButtonVariant.Primary,
            },
            {
                id: "no",
                label: LocaleProvider_1.default.locs.confirmation.no,
                variant: props.cancelButtonType || index_1.ButtonVariant.SecondaryBlue,
            },
        ],
        onClick: function (id) {
            if (id === "yes") {
                success();
            }
        },
    };
    confirmAlert(alertProps);
};
exports.confirmYesNo = confirmYesNo;
var ConfirmAlert = /** @class */ (function (_super) {
    __extends(ConfirmAlert, _super);
    function ConfirmAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClickButton = function (button) {
            var item = String(button.currentTarget.dataset.id);
            if (_this.props.onClick) {
                _this.props.onClick(item);
            }
            _this.close();
        };
        _this.close = function () {
            removeConfirmElement();
        };
        _this.buttons = function () {
            var buttons = _this.props.buttons.map(function (item) {
                return (react_1.default.createElement(index_1.default, { variant: item.variant || index_1.ButtonVariant.SecondaryBlue, key: item.label, "data-id": item.id, onClick: _this.handleOnClickButton }, item.label));
            });
            return react_1.default.createElement("div", { className: "buttons" }, buttons);
        };
        return _this;
    }
    ConfirmAlert.prototype.componentWillUnmount = function () {
        if (this.props.willUnmount) {
            this.props.willUnmount();
        }
    };
    ConfirmAlert.prototype.render = function () {
        return (react_1.default.createElement(index_2.default, { header: this.props.title, allowToClose: false, open: true, buttons: this.buttons },
            react_1.default.createElement("div", { style: { padding: "30px" } }, this.props.message)));
    };
    return ConfirmAlert;
}(react_1.default.Component));
//# sourceMappingURL=index.js.map